import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import SEOHead from '../../components/base/SEOHead';

export default function TermsPage() {
  const { t } = useTranslation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEOHead
        title={t('seo.terms.title')}
        description={t('seo.terms.description')}
        keywords={t('seo.terms.keywords')}
      />
      
      <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-teal-50">
        <Navbar />
        
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
          {/* Hlavička */}
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              Obchodní podmínky
            </h1>
            <p className="text-xl text-gray-600">
              Pravidla poskytování služeb
            </p>
            <p className="text-sm text-gray-500 mt-4">
              Platné od: 1. ledna 2025
            </p>
          </div>

          {/* Obsah */}
          <div className="bg-white rounded-2xl shadow-lg p-8 lg:p-12 space-y-8">
            
            {/* Základní informace */}
            <section>
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-information-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-3">
                    1. Základní informace
                  </h2>
                  <div className="space-y-3 text-gray-700">
                    <p><strong>Provozovatel služby:</strong> VYŽEHLENÉ</p>
                    <div>
                      <p className="font-semibold mb-2">Kontakt:</p>
                      <div className="space-y-1 ml-4">
                        <p className="flex items-center gap-2">
                          <i className="ri-phone-line text-pink-600"></i>
                          Praha: +420 776 166 733
                        </p>
                        <p className="flex items-center gap-2">
                          <i className="ri-phone-line text-teal-600"></i>
                          Stará Boleslav: +420 603 290 573
                        </p>
                      </div>
                    </div>
                    <p className="mt-4">
                      Tyto obchodní podmínky upravují vztah mezi provozovatelem služby VYŽEHLENÉ a zákazníkem při poskytování služeb profesionálního žehlení prádla.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Objednávka */}
            <section className="border-t-2 border-gray-100 pt-8">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-shopping-cart-line text-2xl text-pink-600"></i>
                </div>
                <div className="flex-1">
                  <h2 className="text-2xl font-bold text-gray-900 mb-3">
                    2. Objednávka a uzavření smlouvy
                  </h2>
                  <div className="bg-pink-50 border-2 border-pink-200 rounded-lg p-6 mb-4">
                    <p className="font-semibold text-gray-900 mb-3">Objednávku lze provést:</p>
                    <div className="space-y-2">
                      <p className="flex items-start gap-3">
                        <i className="ri-phone-fill text-pink-600 flex-shrink-0 mt-1"></i>
                        <span>Telefonicky na uvedených kontaktech</span>
                      </p>
                      <p className="flex items-start gap-3">
                        <i className="ri-global-line text-pink-600 flex-shrink-0 mt-1"></i>
                        <span>Prostřednictvím online formuláře na webových stránkách</span>
                      </p>
                      <p className="flex items-start gap-3">
                        <i className="ri-shopping-bag-line text-pink-600 flex-shrink-0 mt-1"></i>
                        <span>Prostřednictvím expresního košíku</span>
                      </p>
                    </div>
                  </div>
                  <p className="text-gray-700">
                    Smlouva je uzavřena potvrzením objednávky ze strany provozovatele. Potvrzení objednávky je zasláno zákazníkovi emailem nebo telefonicky.
                  </p>
                </div>
              </div>
            </section>

            {/* Ceny */}
            <section className="border-t-2 border-gray-100 pt-8">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-money-dollar-circle-line text-2xl text-green-600"></i>
                </div>
                <div className="flex-1">
                  <h2 className="text-2xl font-bold text-gray-900 mb-3">
                    3. Ceny a platební podmínky
                  </h2>
                  <p className="text-gray-700 mb-4">
                    Ceny služeb jsou uvedeny v aktuálním ceníku na webových stránkách. Všechny ceny jsou uvedeny včetně DPH.
                  </p>
                  
                  <div className="grid md:grid-cols-2 gap-4 mb-4">
                    <div className="bg-green-50 border-2 border-green-200 rounded-lg p-4">
                      <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <i className="ri-wallet-line text-green-600"></i>
                        Způsoby platby
                      </h3>
                      <ul className="space-y-2 text-sm text-gray-700">
                        <li className="flex items-start gap-2">
                          <i className="ri-checkbox-circle-fill text-green-600 flex-shrink-0 mt-0.5"></i>
                          <span>Hotově při svozu/převzetí prádla</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <i className="ri-checkbox-circle-fill text-green-600 flex-shrink-0 mt-0.5"></i>
                          <span>Bankovním převodem na základě faktury</span>
                        </li>
                      </ul>
                    </div>

                    <div className="bg-amber-50 border-2 border-amber-200 rounded-lg p-4">
                      <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <i className="ri-time-line text-amber-600"></i>
                        Splatnost
                      </h3>
                      <ul className="space-y-2 text-sm text-gray-700">
                        <li className="flex items-start gap-2">
                          <i className="ri-calendar-check-fill text-amber-600 flex-shrink-0 mt-0.5"></i>
                          <span><strong>5 kalendářních dnů</strong> od vystavení faktury</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <i className="ri-error-warning-fill text-amber-600 flex-shrink-0 mt-0.5"></i>
                          <span>Bez úhrady nebude služba poskytnuta</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Důležité upozornění */}
                  <div className="bg-red-50 border-2 border-red-200 rounded-lg p-4 mb-4">
                    <h3 className="font-bold text-red-900 mb-2 flex items-center gap-2">
                      <i className="ri-alarm-warning-line text-red-600"></i>
                      Důležité platební podmínky
                    </h3>
                    <ul className="space-y-2 text-sm text-red-800">
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-fill text-red-600 flex-shrink-0 mt-0.5"></i>
                        <span><strong>Objednávky se svozem do 5 dnů:</strong> Vyžadujeme platbu v hotovosti při svozu nebo okamžitý bankovní převod s potvrzením.</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-fill text-red-600 flex-shrink-0 mt-0.5"></i>
                        <span><strong>Neuhrazené objednávky:</strong> Prádlo nebude vyžehleno a vráceno, dokud nebude platba uhrazena.</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-right-s-fill text-red-600 flex-shrink-0 mt-0.5"></i>
                        <span><strong>Po splatnosti:</strong> Objednávka může být zrušena a prádlo zadrženo do úhrady.</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-blue-50 border-2 border-blue-200 rounded-lg p-4">
                    <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                      <i className="ri-truck-line text-blue-600"></i>
                      Doprava
                    </h3>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start gap-2">
                        <i className="ri-map-pin-line text-blue-600 flex-shrink-0 mt-0.5"></i>
                        <span>Praha: 399 Kč za obě cesty</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-map-pin-line text-blue-600 flex-shrink-0 mt-0.5"></i>
                        <span>Stará Boleslav: Individuální domluva</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-gift-line text-blue-600 flex-shrink-0 mt-0.5"></i>
                        <span>Doprava zdarma nad 1 700 Kč</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-flashlight-line text-blue-600 flex-shrink-0 mt-0.5"></i>
                        <span>Expresní dodávka do 24h: +500 Kč</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            {/* Poskytování služeb */}
            <section className="border-t-2 border-gray-100 pt-8">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-2xl text-purple-600"></i>
                </div>
                <div className="flex-1">
                  <h2 className="text-2xl font-bold text-gray-900 mb-3">
                    4. Poskytování služeb
                  </h2>
                  
                  <div className="grid md:grid-cols-2 gap-4 mb-4">
                    <div className="bg-purple-50 border-2 border-purple-200 rounded-lg p-4">
                      <p className="font-bold text-purple-900 mb-1">⏱️ Standardní dodací lhůta</p>
                      <p className="text-gray-700">48-72 hodin od vyzvednutí prádla</p>
                    </div>
                    <div className="bg-orange-50 border-2 border-orange-200 rounded-lg p-4">
                      <p className="font-bold text-orange-900 mb-1">⚡ Expresní dodávka</p>
                      <p className="text-gray-700">Do 24 hodin za příplatek 500 Kč</p>
                    </div>
                  </div>

                  <div className="bg-gray-50 border-2 border-gray-200 rounded-lg p-4 mb-4">
                    <h3 className="font-bold text-gray-900 mb-2">Počítání kusů při svozu:</h3>
                    <p className="text-gray-700 text-sm mb-2">
                      Při svozu prádla je spočítán skutečný počet kusů. Pokud se počet liší od objednávky:
                    </p>
                    <ul className="space-y-1 text-sm text-gray-700">
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-up-line text-red-600 flex-shrink-0 mt-0.5"></i>
                        <span><strong>Více kusů:</strong> Doúčtujeme rozdíl při předání</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-arrow-down-line text-green-600 flex-shrink-0 mt-0.5"></i>
                        <span><strong>Méně kusů:</strong> Vrátíme rozdíl při předání</span>
                      </li>
                    </ul>
                  </div>

                  <p className="text-sm text-gray-600 italic">
                    ⚠️ Provozovatel si vyhrazuje právo odmítnout žehlení silně znečištěného nebo poškozeného prádla.
                  </p>
                </div>
              </div>
            </section>

            {/* Storno podmínky */}
            <section className="border-t-2 border-gray-100 pt-8">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-close-circle-line text-2xl text-red-600"></i>
                </div>
                <div className="flex-1">
                  <h2 className="text-2xl font-bold text-gray-900 mb-3">
                    5. Storno podmínky
                  </h2>
                  
                  <div className="grid md:grid-cols-2 gap-4 mb-4">
                    <div className="bg-green-50 border-2 border-green-200 rounded-lg p-4">
                      <p className="font-bold text-green-900 mb-2">✅ Storno více než 24h před svozem</p>
                      <p className="text-gray-700 text-sm">Zdarma, bez poplatků</p>
                    </div>
                    <div className="bg-red-50 border-2 border-red-200 rounded-lg p-4">
                      <p className="font-bold text-red-900 mb-2">⚠️ Storno méně než 24h před svozem</p>
                      <p className="text-gray-700 text-sm">Storno poplatek 100% z ceny objednávky</p>
                    </div>
                  </div>

                  <p className="text-gray-700 text-sm">
                    Storno lze provést telefonicky nebo emailem na kontakty uvedené výše. Podrobné informace najdete v <button onClick={() => window.REACT_APP_NAVIGATE('/storno-podminky')} className="text-pink-600 hover:text-pink-700 font-semibold underline cursor-pointer">Storno podmínkách</button>.
                  </p>
                </div>
              </div>
            </section>

            {/* Reklamace */}
            <section className="border-t-2 border-gray-100 pt-8">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-error-warning-line text-2xl text-yellow-600"></i>
                </div>
                <div className="flex-1">
                  <h2 className="text-2xl font-bold text-gray-900 mb-3">
                    6. Reklamace
                  </h2>
                  
                  <div className="bg-yellow-50 border-2 border-yellow-200 rounded-lg p-4 mb-4">
                    <p className="font-bold text-yellow-900 mb-2">📅 Lhůta pro reklamaci</p>
                    <p className="text-gray-700 text-sm">Zákazník má právo reklamovat službu do 3 dnů od převzetí prádla.</p>
                  </div>

                  <div className="space-y-3 mb-4">
                    <h3 className="font-bold text-gray-900">Jak reklamovat:</h3>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start gap-2">
                        <i className="ri-phone-line text-pink-600 flex-shrink-0 mt-0.5"></i>
                        <span>Telefonicky na uvedených kontaktech</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-mail-line text-pink-600 flex-shrink-0 mt-0.5"></i>
                        <span>Emailem</span>
                      </li>
                    </ul>
                    <p className="text-sm text-gray-600">
                      ⏱️ Provozovatel se zavazuje vyřídit reklamaci do 14 dnů od jejího uplatnění.
                    </p>
                  </div>

                  <div className="bg-gray-50 border-2 border-gray-200 rounded-lg p-4">
                    <h3 className="font-bold text-gray-900 mb-2">Odpovědnost za škody</h3>
                    <p className="text-sm text-gray-700 mb-2">Provozovatel neodpovídá za škody způsobené:</p>
                    <ul className="space-y-1 text-sm text-gray-600">
                      <li className="flex items-start gap-2">
                        <i className="ri-close-line text-gray-500 flex-shrink-0 mt-0.5"></i>
                        <span>Vadným materiálem prádla</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-close-line text-gray-500 flex-shrink-0 mt-0.5"></i>
                        <span>Nesprávným označením složení materiálu výrobcem</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-close-line text-gray-500 flex-shrink-0 mt-0.5"></i>
                        <span>Předchozím poškozením prádla</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-close-line text-gray-500 flex-shrink-0 mt-0.5"></i>
                        <span>Opotřebením prádla</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            {/* GDPR */}
            <section className="border-t-2 border-gray-100 pt-8">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-user-line text-2xl text-indigo-600"></i>
                </div>
                <div className="flex-1">
                  <h2 className="text-2xl font-bold text-gray-900 mb-3">
                    7. Ochrana osobních údajů (GDPR)
                  </h2>
                  <p className="text-gray-700 mb-4">
                    Provozovatel zpracovává osobní údaje zákazníků v souladu s nařízením GDPR (EU) 2016/679.
                  </p>
                  
                  <div className="bg-indigo-50 border-2 border-indigo-200 rounded-lg p-4">
                    <p className="text-sm text-gray-700">
                      Podrobné informace o zpracování osobních údajů najdete v samostatném dokumentu <button onClick={() => window.REACT_APP_NAVIGATE('/zpracovani-osobnich-udaju')} className="text-indigo-600 hover:text-indigo-700 font-semibold underline cursor-pointer">Zpracování osobních údajů</button>.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Závěrečná ustanovení */}
            <section className="border-t-2 border-gray-100 pt-8">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-file-text-line text-2xl text-gray-600"></i>
                </div>
                <div className="flex-1">
                  <h2 className="text-2xl font-bold text-gray-900 mb-3">
                    8. Závěrečná ustanovení
                  </h2>
                  <div className="space-y-3 text-gray-700 text-sm">
                    <p>
                      Tyto obchodní podmínky nabývají účinnosti dnem 1. 1. 2025.
                    </p>
                    <p>
                      Provozovatel si vyhrazuje právo změnit tyto obchodní podmínky. Změny nabývají účinnosti dnem jejich zveřejnění na webových stránkách.
                    </p>
                    <p>
                      Vztahy neupravené těmito obchodními podmínkami se řídí občanským zákoníkem a dalšími souvisejícími právními předpisy České republiky.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Kontakt */}
            <section className="border-t-2 border-gray-100 pt-8">
              <div className="bg-gradient-to-br from-pink-50 to-teal-50 rounded-xl p-6">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Máte dotazy k obchodním podmínkám?
                </h2>
                <p className="text-gray-700 mb-4">
                  Jsme tu pro vás a rádi vám vše vysvětlíme. Neváhejte nás kontaktovat.
                </p>
                <div className="grid md:grid-cols-2 gap-4">
                  <a href="tel:+420776166733" className="flex items-center gap-3 bg-white rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer">
                    <i className="ri-phone-fill text-2xl text-pink-600"></i>
                    <div>
                      <p className="text-sm text-gray-600">Praha</p>
                      <p className="font-bold text-gray-900">+420 776 166 733</p>
                    </div>
                  </a>
                  <a href="tel:+420603290573" className="flex items-center gap-3 bg-white rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer">
                    <i className="ri-phone-fill text-2xl text-teal-600"></i>
                    <div>
                      <p className="text-sm text-gray-600">Stará Boleslav</p>
                      <p className="font-bold text-gray-900">+420 603 290 573</p>
                    </div>
                  </a>
                </div>
              </div>
            </section>

          </div>

          {/* Zpět na hlavní stránku */}
          <div className="text-center mt-12">
            <button
              onClick={() => window.REACT_APP_NAVIGATE('/')}
              className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-pink-600 to-pink-500 text-white rounded-lg font-semibold hover:from-pink-700 hover:to-pink-600 transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl"></i>
              Zpět na hlavní stránku
            </button>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}
